import { render, staticRenderFns } from "./stream-chat-ctrl.vue?vue&type=template&id=b7e06d0a"
import script from "./stream-chat-ctrl.vue?vue&type=script&lang=js"
export * from "./stream-chat-ctrl.vue?vue&type=script&lang=js"
import style0 from "./stream-chat-ctrl.vue?vue&type=style&index=0&id=b7e06d0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports